// Header.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';
import LogoutButton from '../components/LogoutButton';
import ChangePasswordButton from '../components/ChangePasswordButton';
import './Header.css';

const Header = ({ title }) => (
  <div className="header mb-10 flex items-center justify-between">
    <div className="background-rectangle"></div>
    <Link to="/dashboard" className="flex items-center">
      <img src={logo} alt="Logo" className="h-10 w-10 mr-2" />
      <p className="text-3xl font-extrabold tracking-tight text-white">
        {title}
      </p>
    </Link>
    <ChangePasswordButton />
    <LogoutButton />
  </div>
);

export default Header;
